export const QUESTION_OPTIONS = [
    'telegram',
    'email',
    'quickmanage',
    'samsara',
    'motive',
];
export function isQuestionOption(value) {
    return QUESTION_OPTIONS.includes(value);
}
export const ANSWER_KINDS = [
    'answered',
    'unavailable',
    'empty',
    'disabled',
    'failed',
];
export function isAnswerKind(value) {
    return ANSWER_KINDS.includes(value);
}
/**
 * The five buttons, each covering every instance of its plugin. A deployment
 * with three Samsara organisations has one Samsara button that searches all
 * three, exactly as the Email button has always covered every mailbox.
 *
 * Availability is not decided here: a button is live when an instance of that
 * kind is configured, which only the registry and the source directory know.
 */
export function questionBindings() {
    const bind = (option, label, strategy) => ({ option, label, strategy, sourcePrefix: `${option}:` });
    return [
        bind('telegram', 'Telegram', 'stored'),
        bind('email', 'Email', 'stored'),
        bind('quickmanage', 'QuickManage', 'live'),
        bind('samsara', 'Samsara', 'live'),
        bind('motive', 'Motive', 'live'),
    ];
}
//# sourceMappingURL=question.js.map